import { QueryStateIndicator } from "@components/QueryStateIndicator";
import { useDeploymentDetail } from "@libs/api/gateways/field/field-ops-gateway.hooks";

import { DeploymentDetailSection } from "./DeploymentDetailSection";

interface DeploymentDetailHostProps {
  fieldDeviceId: string;
}

export const DeploymentDetailHost: React.FC<DeploymentDetailHostProps> = ({
  fieldDeviceId
}) => {
  const deploymentDetailQuery = useDeploymentDetail(fieldDeviceId);

  return (
    <QueryStateIndicator {...deploymentDetailQuery}>
      {detail => <DeploymentDetailSection detail={detail} />}
    </QueryStateIndicator>
  );
};
